import {
  getPageAccessorUrlForUrl
} from './page_accessor.js';

import { 
  openWindow,
  openVersionWindow,
  openVersionMobileWindow,
  openPreviewWindow,
  openPreviewMobileWindow,
  openPublishedWindow,
  openPublishedMobileWindow
} from 'zoomforth_page_version_viewer/utils.js';

const viewPageInNewTab = ({
  urlId,
  version,
  canonicalUrl,
  subpageId,
  forcePreview,
  themeUuid, // Note this only works if we are previewing
  siteViewerVersion // Note this only works if we are previewing
}) => {
  if (forcePreview) {
    openPreviewWindow(urlId, { subpageId, themeUuid, siteViewerVersion });

  } else if (version) {
    openVersionWindow(urlId, version);

  } else if (canonicalUrl) {
    openWindow(getPageAccessorUrlForUrl(canonicalUrl), `_page_accessor_${urlId}`);

  } else {
    openPublishedWindow(urlId);
  
  }
};

const viewMobilePageInNewTab = ({
  urlId,
  version,
  subpageId,
  forcePreview,
  themeUuid
}) => {
  if (forcePreview) {
    openPreviewMobileWindow(urlId, { subpageId, themeUuid });

  } else if (version) {
    openVersionMobileWindow(urlId, version);

  } else {
    openPublishedMobileWindow(urlId);
  
  }
};

export { viewPageInNewTab, viewMobilePageInNewTab };
